import "@assets/css/bootstrap-grid.css";
import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { useQueryClient } from "@tanstack/react-query";
import { SkeletonTwo } from "@ui/external/components/skeleton";
import { getInputField } from "@utils/function/index.function";
import { showToast, throwErrorAlert } from "@utils/helper/index.helper";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import { FormField } from "@utils/interface/form.interface";
import {
  TeamsLicenseData,
  TeamsLicenseSchema,
} from "@utils/interface/form.schema";
import { IndividualQuery } from "@utils/interface/index.interface";
// import { StudentData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { usePending, useSelectionStore } from "@utils/states/index.state";
import React, { useEffect, useMemo } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useParams } from "react-router";
import { toast } from "sonner";

const MicroSoftTeamsForm: React.FC = () => {
  const queryClient = useQueryClient();
  const { searchParams, handleAction } = useHandleAction({});
  const { type } = useParams();
  const modalItem = searchParams.get("modal-item");
  const pathname = usePathname();
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<TeamsLicenseData>({
    mode: "onChange",
    resolver: zodResolver(TeamsLicenseSchema),
    defaultValues: {
      is_coding: false,
    },
  });

  console.log("this is the form value", watch());

  /* set default value */
  const { setIsRetrive }: any = usePending();
  const { setIsFormPending } = useSelectionStore();

  const { data, isPending: fetchPending } = useListData<
    IndividualQuery<TeamsLicenseData>
  >({
    endpoint: endpoint["teamsLicense"],
    id: modalItem || "",
    key: "teamsLicense" + modalItem,
    enabled: !!modalItem,
  });

  // const { data: students, isPending: studentFetching } = useListData<
  //   IndividualQuery<StudentData>
  // >({
  //   endpoint: endpoint["student"],
  //   id: modalItem || "",
  //   key: "student" + modalItem,
  //   enabled: !modalItem,
  // });

  console.log("this is the teams Licenese Data", data);

  useEffect(() => {
    setIsRetrive(modalItem ? fetchPending : false);
    if (data) {
      if (searchParams.get("modal") == "add") {
        return reset({});
      } else {
        const apiData = data?.data as any;
        reset({
          teams_email: apiData?.teams_email,
          teams_password: apiData?.teams_password,
          student: [
            {
              label: apiData?.student?.user?.full_name,
              value: apiData?.student?.id,
            },
          ],
          is_coding: apiData?.is_coding,
        });
      }
    }
  }, [data, fetchPending]);

  const { mutate, isPending } = usePostData();
  /* muta te action */
  const handleMutate = (data: Partial<any>) => {
    setIsFormPending(true);

    // @ts-ignore
    data = {
      ...data,
      // full_name: `${data.first_name} ${data.last_name}`,
      latest_email_sent_at: null,
      student: data?.student[0]?.value,
      id: modalItem,
    };

    delete data.first_name;
    delete data.last_name;
    delete data.email;
    console.log("Submitted data in handle mutate:", data);
    return {
      data,
      endpoint: endpoint["teamsLicense"],
      method: modalItem ? METHODS.PUT : METHODS.POST,
    };
  };
  const handleSuccess = async ({ status }: { data: any; status: number }) => {
    if ([200, 201].includes(status)) {
      queryClient.invalidateQueries({ queryKey: [`${pathname}-listing`] });
      queryClient.invalidateQueries({
        queryKey: [`${pathname}-listing-scroll`],
      });
      setIsFormPending(false);
      handleAction({ type: "modal-close" });
      showToast({
        description: `${pathname} ${status === 200 ? "Updated" : "Created"}`,
        type: "success",
        title: "Success",
      });
    } else {
      return new Error("Unknown API Error");
    }
  };

  const handleError = async (error: any) => {
    setIsFormPending(false);
    console.log("mutation pending status in", error?.data?.status);
    if (error?.data?.status == 413) {
      toast.error("File size too large");
    }
    setIsFormPending(false);
    const errorMessage = error.data.response.data;
    throwErrorAlert(errorMessage);
  };

  const onSubmit: SubmitHandler<TeamsLicenseData> = (data) => {
    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });
  };

  const formSchema: FormField[] = useMemo(
    () => [
      // {
      //   name: "first_name",
      //   label: "First Name",
      //   colSpan: 6,
      //   type: "text",
      //   placeholder: "Enter first name",
      //   control: control,
      //   setValue: setValue,
      //   errors,
      //   className: `mb-[20px] min-w-full w-full`,
      //   visable: true,
      // },
      // {
      //   name: "last_name",
      //   label: "Last Name",
      //   colSpan: 6,
      //   type: "text",
      //   placeholder: "Enter last name",
      //   control: control,
      //   setValue: setValue,
      //   errors,
      //   className: `mb-[20px] min-w-full w-full`,
      //   visable: true,
      // },
      {
        name: "teams_email",
        label: "Teams Email",
        colSpan: 12,
        type: "text",
        placeholder: "Enter email",
        control: control,
        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        name: "teams_password",
        label: "Teams Password",
        colSpan: 12,
        type: "text",
        placeholder: "Enter Password",
        control: control,
        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      // {
      //   name: "student",
      //   label: "Student",
      //   colSpan: 12,
      //   type: "async",
      //   placeholder: "Select Student",
      //   control: control,
      //   endpoint: endpoint["student"],
      //   option: students?.data?.results?.map((item: any) => ({
      //     label: item.email,
      //     value: item.id,
      //   })),
      //   setValue: setValue,
      //   errors,
      //   disabled: !!modalItem,
      //   className: `mb-[20px] min-w-full w-full`,
      //   visable: true,
      // },
      {
        name: "student",
        label: "Student",
        accordian_label: "Student",
        colSpan: 12,
        type: "async",
        endpoint: endpoint["student"],
        settings: { add: true, update: true, remove: true, debounce: 1000 },
        format: {
          key: "first_name",
          secondary_key: "email",
          value: "id",
          mutate: "name",
        },

        placeholder: "Enter Student",
        control: control,
        setValue: setValue,
        errors,
        className: `mb-[20px] min-w-full w-full`,
        visable: true,
      },
      {
        name: "is_coding",
        label: "Is Coding",
        colSpan: 12,
        type: "switch",
        control: control,
        setValue: setValue,
        errors,
        visable: true,
      },
      {
        type: "submit",
        value: `${searchParams.get("modal") || ""} ${(
          type || pathname
        )?.replace("-", " ")}`,
        className: "w-full h-[47px] mt-[32px] capitalize",
        colSpan: 12,
        variant: "default",

        endIcon: isPending ? <Spinner /> : null,
        disabled: isPending ? true : false,
        visable: true,
      },
    ],
    [control, setValue, errors, isPending],
  );

  if (fetchPending && modalItem)
    return (
      <>
        <SkeletonTwo />
      </>
    );
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="row w-full">
        {formSchema.map(
          (field, index) =>
            (field.visable || field.visable == undefined) && (
              <div
                key={index}
                className={`col-lg-${field.colSpan} col-12 lg:px-[12px] px-[8px]`}
              >
                {getInputField({ ...field })}
              </div>
            ),
        )}
      </form>
    </>
  );
};

export default MicroSoftTeamsForm;
